import { defaultTo } from 'lodash';
import {
  IModel,
  Model,
  ModelRecord,
  OrganizationListingModel,
} from '@common/models';

export interface ISalesItemPriceRuleOrganizationModel extends IModel {
  salesItemPriceRuleOrganizationId: number;
  salesItemPriceRuleId: number;
  organizationId: number;
  organization: OrganizationListingModel;
}

export class SalesItemPriceRuleOrganizationModel
  extends Model
  implements ModelRecord<ISalesItemPriceRuleOrganizationModel>
{
  salesItemPriceRuleOrganizationId: number;
  salesItemPriceRuleId: number;
  organizationId: number;
  organization: OrganizationListingModel;

  constructor(params?: Partial<ISalesItemPriceRuleOrganizationModel>) {
    super(params);
    this.salesItemPriceRuleOrganizationId = defaultTo(
      params?.salesItemPriceRuleOrganizationId,
      0,
    );
    this.salesItemPriceRuleId = defaultTo(params?.salesItemPriceRuleId, 0);
    this.organizationId = defaultTo(params?.organizationId, 0);
    this.organization = params?.organization
      ? new OrganizationListingModel(params.organization)
      : new OrganizationListingModel();
  }
}
